import { date, money } from "@/lib/format";
import { Card, PageHeader } from "@/components/ui";
import { useAuth } from "@/state/auth";

export function Settings() {
  const { account } = useAuth();
  return (
    <>
      <PageHeader title="Settings" subtitle="Account, billing and team." />

      <div className="grid gap-5 lg:grid-cols-2">
        <Card>
          <h2 className="mb-4 text-lg font-semibold tracking-tight">Account</h2>
          <dl className="space-y-3 text-sm">
            <Row label="Account code" value={account?.code ?? "-"} />
            <Row label="Name" value={account?.trading_name || account?.legal_name || "-"} />
            <Row label="Type" value={account?.type === "business" ? "Business" : "Individual"} />
            <Row label="Billing email" value={account?.billing_email ?? "-"} />
            <Row label="Billing mode" value={account?.billing_mode === "invoiced" ? "Invoiced monthly" : "Prepaid"} />
            <Row label="Balance" value={money(account?.balance_cents)} />
            <Row label="Customer since" value={date(account?.created_at)} />
          </dl>
        </Card>

      </div>
    </>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between gap-4">
      <dt className="text-ink-400">{label}</dt>
      <dd className="text-right font-medium">{value}</dd>
    </div>
  );
}
